import { render, staticRenderFns } from "./BidResulDetail.vue?vue&type=template&id=0a4bbb11&scoped=true&"
import script from "./BidResulDetail.vue?vue&type=script&lang=js&"
export * from "./BidResulDetail.vue?vue&type=script&lang=js&"
import style0 from "./BidResulDetail.vue?vue&type=style&index=0&id=0a4bbb11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4bbb11",
  null
  
)

export default component.exports